const Operation = () => {
  return <>Operations Page</>;
};

export default Operation;
